<template>
  <div class="bottom-block">
    <div>
      <a class="red-link" target="_blank" href="https:\/\/jimmyroland.com">Created by Jimmy Roland</a>
    </div>
    <div>
      <small>This site is not affiliated with Nintendo and is only a tool to help share Nintendo's Friend Code online identifiers. Check the <a class="red-link" target="_blank" href="/privacy.html">privacy policy</a>.</small>
    </div>
    <div>Please consider donating if you enjoy this service. This project has never covered operating costs so every bit helps.</div>
    <crypto-donate />
  </div>
</template>

<style>
form {
  padding-top: 0.5em;
}
.red-link {
  color: red;
}
.strong {
  font-weight: 600;
}
</style>

<script>
import CryptoDonate from "./CryptoDonate.vue";
export default {
  components: { CryptoDonate },
  name: "Footer",
  data() {
    return {};
  },
};
</script>
